// @ts-check
import {
  GET_AVAILABLE_NODES,
  GET_AVAILABLE_TAGS,
  GET_AVAILABLE_VOICES,
  GET_CALL_FLOW_TREES,
  GET_CALL_FLOW_TREE,
  DUPLICATE_CALL_FLOW_TREE,
  DELETE_CALL_FLOW_TREE,
  ATTACH_NODE,
  UPDATE_NODE,
  GET_CALL_FLOW_TREE_REFERENCES,
  SAVE_TREE,
  SAVE_DRAFT,
  CONVERT_TEXT_TO_SPEECH
} from './actionTypes';
import { getActionStatusName, isLoading as loaderGetter } from '@/store/helpers';
import nodeStyleData from '../helpers/nodeStyleData';
import { mergeNodeData } from '../helpers/callFlow';

export const isLoading = loaderGetter;

export const getAvailableNodesStatus = state => state.status[getActionStatusName(GET_AVAILABLE_NODES)] || {};
export const getAvailableTagsStatus = state => state.status[getActionStatusName(GET_AVAILABLE_TAGS)] || {};
export const getAvailableVoicesStatus = state => state.status[getActionStatusName(GET_AVAILABLE_VOICES)] || {};
export const getCallFlowTreesStatus = state => state.status[getActionStatusName(GET_CALL_FLOW_TREES)] || {};
export const getCallFlowTreeStatus = state => state.status[getActionStatusName(GET_CALL_FLOW_TREE)] || {};
export const getCallFlowTreeReferencesStatus = state => state.status[getActionStatusName(GET_CALL_FLOW_TREE_REFERENCES)] || {};
export const getDuplicateCallFlowTreeStatus = state => state.status[getActionStatusName(DUPLICATE_CALL_FLOW_TREE)] || {};
export const getDeleteCallFlowTreeStatus = state => state.status[getActionStatusName(DELETE_CALL_FLOW_TREE)] || {};
export const getAttachNodeStatus = state => state.status[getActionStatusName(ATTACH_NODE)] || {};
export const getUpdateNodeStatus = state => state.status[getActionStatusName(UPDATE_NODE)] || {};

export const getSaveTreeStatus = state => state.status[getActionStatusName(SAVE_TREE)] || {};

export const getSaveDraftStatus = state => state.status[getActionStatusName(SAVE_DRAFT)] || {};

export const convertTextToSpeechStatus = state => state.status[getActionStatusName(CONVERT_TEXT_TO_SPEECH)] || {};

export const callFlowTreeId = state => state.callFlowTree.id;

export const availableNodesWithStyling = state => {
  return mergeNodeData(state.availableNodes, nodeStyleData);
};

export const availableNodesMapping = state => {
  return state.availableNodes.reduce((previousValue, currentValue) => {
    previousValue[currentValue.nodeTypeId] = currentValue;

    return previousValue;
  }, {});

};